import React, { useState, useEffect, useRef } from "react";

import * as api from "helper/helper";
import toast from "react-hot-toast";

import { FaPlus } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
//import CreateClient from "./CreateClient";

import "./../Usuarios/usuarios.css";
//import { buildNameWithId, range } from "helper/tools";
//import TableOptionCheck, { FilterType } from "../Productos/TableOptionCheck";
//import buttonStyles from "../../../../styles/Button.module.css";
//import menuStyle from "../../../../styles/Menu.module.css";
//import SearchBar from "../SearchBar";

import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import PagedFetch, {
  //buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
//import FilterButton from "../FilterButton/FilterButton";
//import TableOptionCheck, { FilterType } from "../Productos/TableOptionCheck";
import { buildNameWithId } from "helper/tools";
import CardFilter from "../CardFilter";
import CreditLevelTable from "../LimitLevels/CreditLevelTable";
import AddressView from "../Address/AddressView";

export default function NotificacionesDashboard() {
  const createClientesRef = useRef();

  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [limitsPendings, setLimitsPendings] = useState([
    /*{
        id: 1,
        nombre: "Pero Monito",
        fecha: new Date(2016, 11, 21),
        operacion: {
          tipo: "limite_credito",
          status: "Pendiente",
          valor: 30000,
          nuevo_valor: 56000,
          nota: "esto esto otro bla bla",
          credito: 9393,
        },
      },
      {
        id: 2,
        nombre: "mona china fefefe",
        fecha: new Date(2016, 11, 19),
        operacion: {
          tipo: "limite_credito",
          status: "Aprobado",
          valor: 5000,
          nuevo_valor: 33500,
          nota: "se puede??",
          credito: 2222,
        },
      },
      {
        id: 3,
        nombre: "pepe pecas",
        fecha: new Date(2016, 11, 17),
        operacion: {
          tipo: "limite_credito",
          status: "Cancelado",
          valor: 1000,
          nuevo_valor: 98000,
          nota: "haber si pega",
          credito: 922,
        },
      },*/
  ]);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });
  /** FILTERS */
  const [asociados, setAsociados] = useState([]);

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({
    tipoDeSolicitudes: ["LimiteCredito"],
  });
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  const fetchData = async () => {
    setIsLoading(true);
    let criteria = searchCriteria;
    /// reset pag info
    pagingInfoRef.current.resetPageInfo();

    criteria = pagingInfoRef.current.buildFetch(criteria);
    //  searchFetchData(criteria);

    const responseAsociados = await api.asociados().catch((error) => {
      toast.error("Error al pedir Asociados.");
      setIsLoading(false);
    });

    if (!responseAsociados) return;

    const autoAsociados = responseAsociados.data.map((item) => {
      const text = buildNameWithId(item, item.numAsociado);
      return { id: item.id, nombre: text };
    });
    setAsociados(autoAsociados);

    ///
    let responseChangeLevelCredit = await api
      .asociadosSolicitudes()
      .catch((e) => {
        console.log(e);
      });
    if (responseChangeLevelCredit) {
      setLimitsPendings(responseChangeLevelCredit.data);
    }
  };

  useEffect(() => {
    fetchData();

    const newPermissions = PermissionsForSection(Sections.Clientes);
    setPermissions(newPermissions);
  }, []);

  function createClient(event) {
    console.log(event);
    loadItem({});
  }

  ///--
  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createClientesRef);
    setModalData(item);

    createClientesRef.current.toggleModal();
  }

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  function goPreviousPage() {
    let page = pagingInfoRef.current.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    let page = pagingInfoRef.current.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    pagingInfoRef.current.updatePageNumber(pageNumber);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    //  searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    //searchFetchData(criteria);
  }

  const handleFilterChange = (filter) => {
    //setFilter(filter);
  };

  const buttonModalEditRef = useRef();
  const buttonModalRef2 = useRef();

  const tryApprove = async (item) => {
    fetchData();
  };

  function reloadCredit() {
    fetchData();
  }

  const childToParent = (data) => {
    //  setAddressViewCurrent(data);
    //setModalData(data);
    //  buttonModalRef.current.click();
  };

  const addressView = useRef(null);

  const createAsociadosRef = useRef(null);

  const [editAddress, setEditAddress] = useState(null);
  const modalRef = useRef();

  function saveAddress(event) {
    const value = addressView.current.getValue();
    addressView.current.clear();
    console.log(value);

    let newModalData = { ...modalData };
    if (modalData == null) {
      newModalData = createAsociadosRef.current.getValue();
    }

    if (value.id === 0) {
      let newId = newModalData.direcciones.reduce(
        (accumulator, currentValue) =>
          accumulator < currentValue.id ? accumulator : currentValue.id,
        0,
      );
      console.log(" --- " + newId);
      value.id = newId - 1;
      newModalData.direcciones.push(value);
    } else {
      const index = newModalData.direcciones.findIndex(
        (item) => item.id === value.id,
      );
      if (index !== -1) {
        newModalData.direcciones.splice(index, 1, value);
      }
    }

    setModalData(newModalData);

    //console.log(modalData);
    console.log("saveAdd");
  }

  return (
    <>
      {/*<CreateClient
        ref={createClientesRef}
        item={modalData}
        reloadClientes={reloadClientes}
      />*/}

      <div className="card recent-sales overflow-auto">
        {/*<CardFilter filterChange={handleFilterChange} />*/}
        <div className="card-body">
          <h5 className="card-title">
            Solicitudes de Cambios en Asociados
            <span>
              <button
                ref={buttonModalEditRef}
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
                hidden
              >
                <div>
                  <FaPlus />
                  Crear
                </div>
              </button>
            </span>
            <span hidden>
              <button
                ref={buttonModalRef2}
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop3"
              >
                <div>
                  <FaPlus />
                  MODI
                </div>
              </button>
            </span>
          </h5>

          {/*<SearchBar />

        <div className="row">
          <div className="col-3">
            <span>Ordenar</span>
            <select className="form-select" aria-label="Default select example">
              <option selected>Selecciona Sucursal</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>
          <div className="col-3">
            <span>Ordenar</span>
            <select className="form-select" aria-label="Default select example">
              <option selected>Selecciona responsable</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>
        </div>*/}

          <CreditLevelTable
            items={limitsPendings}
            openItem={loadItem}
            tryApprove={tryApprove}
            reloadCredit={reloadCredit}
          />
        </div>

        <div
          ref={modalRef}
          className="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          {/*<CreateAsociados
            ref={createAsociadosRef}
            item={modalData}
            callNewEditModal={newEditModal}
            reloadAsociados={reloadAsociados}
          />*/}
        </div>

        <div
          className="modal fade"
          id="staticBackdrop3"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdrop3Label"
          aria-hidden="true"
          style={{ zIndex: 1600 }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdrop3Label">
                  {editAddress && Object.keys(editAddress).length > 0
                    ? "Editar"
                    : "Crear"}{" "}
                  dirección
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <AddressView
                  ref={addressView}
                  item={editAddress}
                  childToParent={childToParent}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  onClick={(e) => saveAddress(e)}
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Modal title
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">...</div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
